import React, { useRef } from 'react';

import { useOutsideClick } from 'utils/custom-hooks';
import { ratesService } from './rates-service';

import './retailer-inactivity-modal.scss';

const RetailerInactiveModal = ({setDisplayModal, retailer, getRetailer}) => {
	const modal = useRef(false);
	useOutsideClick(modal, () => setDisplayModal(false));

	function changeRetailerActivity() {
		setDisplayModal(false);
		ratesService.updateMerchantPublisherNetwork(
			{in_network: false, merch_id: retailer.merch_id}
		);
		getRetailer();
	}
	return (
		<div className="inactivity-modal-container">
			<div className="inactivity-modal" ref={(node) => modal.current = node}>
				<h2>{`Make ${retailer.merchant_name} Inactive?`}</h2>
				<p>{`You will no longer generate earnings by sending traffic to ${retailer.merchant_name},
						and they will be removed from multi-matched links`}
				</p>
				<div className="btn-container">
					<button className="btn cancel" onClick={() => setDisplayModal(false)}>Cancel</button>
					<button className="btn opt-out" onClick={changeRetailerActivity}>Opt-Out</button>
				</div>
			</div>
		</div>
	);
};

export default RetailerInactiveModal;
